// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const CEREBRAS_MODELS = {
	"gemma-4-31b": {
		id: "gemma-4-31b",
		name: "Gemma 4 31B IT",
		api: "openai-completions",
		provider: "cerebras",
		baseUrl: "https://api.cerebras.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.99,
			output: 1.49,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 40960,
	} satisfies Model<"openai-completions">,
	"gpt-oss-120b": {
		id: "gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "openai-completions",
		provider: "cerebras",
		baseUrl: "https://api.cerebras.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.35,
			output: 0.75,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 40960,
	} satisfies Model<"openai-completions">,
	"zai-glm-4.7": {
		id: "zai-glm-4.7",
		name: "Z.AI GLM-4.7",
		api: "openai-completions",
		provider: "cerebras",
		baseUrl: "https://api.cerebras.ai/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 2.25,
			output: 2.75,
			cacheRead: 2.25,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 40960,
	} satisfies Model<"openai-completions">,
} as const;
